import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Table, Button } from 'reactstrap'
import ScrollBar from 'react-perfect-scrollbar'
import * as CurrencyFormat from 'react-currency-format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from '../../../store/rootReducer'
import { QACheck } from '../../../lib/interfaces/QACheck.interface'

import FileList from 'src/common/FileList.component'
import Collapsible from '../../../common/Collapsible.component'

import * as qaChecksActions from '../../../store/qaChecks/actions'

const moment = require('moment')

const get = require('lodash/get')
const map = require('lodash/map')
const compact = require('lodash/compact')
const isEmpty = require('lodash/isEmpty')

export interface CurrentQACheckProps {
  qaCheck: QACheck
  isFetchingFiles: boolean
  resetCurrentQACheck: () => void
}

class CurrentQACheck extends React.Component<CurrentQACheckProps> {
  constructor(props: CurrentQACheckProps) {
    super(props)

    this.handleEscapeKey = this.handleEscapeKey.bind(this)
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleEscapeKey)
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEscapeKey)
  }

  get filesCollapsibleTitle() {
    const { qaCheck } = this.props

    if (qaCheck.files) {
      return `Files (${qaCheck.files.length || 0})`
    }

    return 'Files'
  }

  handleEscapeKey(e) {
    if (e.keyCode === 27) {
      this.handleResetCurrentQACheck(e)
    }
  }

  handleResetCurrentQACheck = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    this.props.resetCurrentQACheck()
  }

  renderLocation() {
    const { qaCheck } = this.props

    return (
      <p className="mb-1">
        <b>Location: </b>
        {get(qaCheck, 'locationPosition.location.code', '-')}
      </p>
    )
  }

  // renderEmployee() {
  //   const { qaCheck } = this.props

  //   const employeeNames = compact([ get(qaCheck, 'employee.firstName'), get(qaCheck, 'employee.lastName') ])

  //   if (employeeNames.length === 0) {
  //     return 'No name'
  //   }

  //   return employeeNames.join(' ')
  // }

  render() {
    const { qaCheck, isFetchingFiles } = this.props

    return (
      <div className="col-md-4 sidedetails" onKeyPress={e => console.log(e.keyCode)}>
        <div className="d-flex flex-column h-100 p-4">
          <div className="d-flex justify-content-between align-items-center">
            <h4>
              {qaCheck.vin}
            </h4>
            <a href="" className="sidedetails-close mx-2" onClick={this.handleResetCurrentQACheck}>
              <FontAwesomeIcon icon={['fas', 'times-circle']} />
            </a>
          </div>
          <div className="mb-3">
            <p className="mb-1">
              <b>Driver ID: </b>
              {qaCheck.driverId}
            </p>
            {this.renderLocation()}
            <p className="mb-1">
              <b>Date: </b>
              {moment(qaCheck.timeChecked).format('MM/DD/YYYY hh:mm A')}
            </p>
          </div>

          <ScrollBar className="flex-grow-1 min-height-0">
            <Collapsible defaultOpen title={this.filesCollapsibleTitle} icon={['far', 'save']} isLoading={isFetchingFiles}>
              {isFetchingFiles &&
                <span className="d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
                  Loading
                </span>
              }
              {!isFetchingFiles && (
                isEmpty(qaCheck.files)
                  ? <span className="d-flex align-items-center justify-content-center">No files</span>
                  : (
                    <FileList
                      viewMode="card"
                      entity="qaCheck"
                      files={qaCheck.files}
                      entityId={qaCheck.id}
                      fileWrapperClassName="list-group-item"
                      className="gglist list-group list-group-flush"
                    />
                  )
              )}
            </Collapsible>
          </ScrollBar>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  qaCheck: state.qaChecks.currentQACheck,
  isFetchingFiles: state.qaChecks.isFetchingFiles
})

const mapDispatchToProps = (dispatch) => ({
  resetCurrentQACheck: () => dispatch(qaChecksActions.setCurrentQACheck(undefined))
})

export default connect(mapStateToProps, mapDispatchToProps)(CurrentQACheck)



// WEBPACK FOOTER //
// ./src/routes/qa-checks/components/CurrentQACheck.component.tsx